import { formatter, Ajax } from './common_product_list_pro'
cb.define([], function() { //商品列表
  var PC_pc_productlist_shop_VM_Extend = {
    doAction: function(name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function(viewmodel) {
      formatter(viewmodel)
      let gridModel = viewmodel.getGridModel();
      gridModel.on('beforeDblClick', (args) => {
        args.source = 'business';           
        args.carryParams.productApplyRangeId = args.rowData.productApplyRangeId;                
        args.carryParams.isCreator = args.rowData.isCreator;                
        args.carryParams.isApplied = args.rowData.isApplied;   
        args.ids = {
          customerId: args.rowData.customerId,
          shopId: args.rowData.shopId,
          orgId: args.rowData.orgId
        }
      })
      let selectRows = []
      let auditargs;
      gridModel.on('afterSetDataSource', (rows) => {
        let actionStates = [];
        rows.forEach(row => {
          let actionState = {
            btnAudit: { visible: false },
            btnForceDown: { visible: false },
            btnReUp: { visible: false }
          }
          let platFormStaus = (row.platFormStaus == 0 || row.platFormStaus == 2) // 0 未审核
          actionState['btnAudit'] = { visible: platFormStaus }
          actionState['btnForceDown'] = { visible: (row.platFormStaus == 1 && (row['detail!mallupcount'] || row['detail!uorderupcount'])) }
          actionState['btnReUp'] = { visible: row.platFormStaus == 3 }
          actionStates.push(actionState);
        });
        gridModel.setActionsState(actionStates);
      })
      // 批量审核
      function _fnaudit(args) {
        let datas = selectRows.map(v => {
          return {
            id: v.id,
            value: args.value,
            state: args.state
          }
        })
        Ajax(auditargs, datas, viewmodel)
      }

      function _fnforcedown(args) {
        let datas = selectRows.map(v => {
          return {
            "id": v.id,
            "productApplyRangeId": v.productApplyRangeId,
            "value": args.value
          }
        })
        Ajax(auditargs, datas, viewmodel)
      }

      viewmodel.on('audit', (args) => {
        selectRows.length = 0
        auditargs = args;
        if (args.params) {
          if (args.params.index < 0) {
            cb.utils.alert('未选择商品！', 'warning');
            return false;
          }
          selectRows.push(gridModel.getRow(args.params.index));
        } else {
          selectRows = gridModel.getSelectedRows();
          if (!selectRows.length) {
            cb.utils.alert('未选择商品！', 'warning');
            return false;
          }
          let _selectRows = selectRows.filter(v => v.platFormStaus == 0 || v.platFormStaus == 2)
          if (!_selectRows.length) {
            cb.utils.alert('请选择未审核的商品', 'warning');
            return false;
          }
          selectRows = _selectRows
        }
        viewmodel.communication({
          type: 'modal',
          payload: {
            key: 'Audit',
            data: {
              model: viewmodel
            }
          }
        });
      })

      viewmodel.on('forcedown', (args) => {
        selectRows.length = 0
        auditargs = args;
        if (args.params) {
          if (args.params.index < 0) {
            cb.utils.alert('未选择商品！', 'warning');
            return false;
          }
          selectRows.push(gridModel.getRow(args.params.index));
        } else {
          selectRows = gridModel.getSelectedRows();
          if (!selectRows.length) {
            cb.utils.alert('未选择商品！', 'warning');
            return false;
          }
          let _selectRows = selectRows.filter(v => {
            let platFormStaus = (v.platFormStaus == 0 || v.platFormStaus == 2 || v.platFormStaus == 3)
            return !platFormStaus && (v['detail!mallupcount'] || v['detail!uorderupcount'])
          })
          if (!_selectRows.length) {
            cb.utils.alert('请选择需要违规下架的商品', 'warning');
            return false;
          }
          selectRows = _selectRows
        }
        viewmodel.communication({
          type: 'modal',
          payload: {
            key: 'ForceDown',
            data: {
              model: viewmodel
            }
          }
        });
      })
      viewmodel.on('reup', (args) => {
        selectRows.length = 0
        if (args.params) {
          if (args.params.index < 0) {
            cb.utils.alert('未选择商品！', 'warning');
            return false;
          }
          selectRows.push(gridModel.getRow(args.params.index));
        } else {
          selectRows = gridModel.getSelectedRows();
          if (!selectRows.length) {
            cb.utils.alert('未选择商品！', 'warning');
            return false;
          }
          let _selectRows = selectRows.filter(v => v.platFormStaus == 3)
          if (!_selectRows.length) {
            cb.utils.alert('请选择需要恢复上架的商品', 'warning');
            return false;
          }
          selectRows = _selectRows
        }
        let datas = selectRows.map(v => {
          return {
            "id": v.id,
            "productApplyRangeId": v.productApplyRangeId
          }
        })
        Ajax(args, datas, viewmodel)
      })
      viewmodel.on('handleAudit', (args) => {
        _fnaudit(args)
      })
      viewmodel.on('handleForcedown', function(args) {
        _fnforcedown(args)
      })
    }
  }
  try {
    module.exports = PC_pc_productlist_shop_VM_Extend;
  } catch (error) {
    // 当 类型 为 档案 的时候
  }
  return PC_pc_productlist_shop_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_productlist_shop_VM.Extend.js